<template>
  <el-dialog title="处理预警" :visible.sync="visible" class="solveDialog" :modal-append-to-body="false"
    :close-on-click-modal="true" @opened="openDialog" :append-to-body="true">
    <div style="padding: 20px 30px">
      <el-form label-position="left" label-width="112px" :model="formData">
        <el-form-item label="处理结果">
          <el-select v-model="formData.status" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="处理说明">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
      </el-form>

      <div style="text-align: center">
        <el-button class="btn3" @click="handleSubmit">确定</el-button>
        <el-button class="btn4" @click="closeDialog">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      visible: false,
      datalist: {},
      formData: {
        id: "",
        status: "",
        description: ""
      },
      options: [
        // {
        //   value: "1",
        //   label: "未处理"
        // },
        {
          value: "2",
          label: "忽略"
        },
        {
          value: "3",
          label: "已处理"
        },
        {
          value: "4",
          label: "误报"
        }
      ],
      showB: false,
      btnText: "播放"
    };
  },
  methods: {
    openDialog() {
      this.formData = {
        id: this.formData.id,
        status: this.formData.status == "1" ? '' : this.formData.status,
        description: this.formData.description
      }
    },
    show(id, status, description) {
      this.formData.id = id;
      this.formData.status = status
      this.formData.description = description
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    handleSubmit() {
      const params = {
        description: this.formData.description,
        id: this.formData.id,
        status: this.formData.status,
      };
      this.$api.warning
        .handleWarning(params)
        .then((res) => {
          if (res.success) {
            this.closeDialog();
            this.$emit('getWarningList')
            this.$message.success("已提交");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
        });
    },

  }
}
</script>

<style lang="less" scoped>
.solveDialog {
  /deep/ .el-textarea__inner {
    background: transparent;
    width: 80%;
    height: 80px;
    color: white;
    border: 1px solid #505052;
  }
}

.btn3 {
  width: 120px;
  height: 38px;
  background: #219E82;
  border-radius: 2px;
  border: 0.0625rem solid #219E82;
  color: white;
  cursor: pointer;
}

.btn3:hover {
  background: #44D7B6;
}

.btn4 {
  width: 120px;
  height: 38px;
  border-radius: 2px;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  cursor: pointer;
}

.btn4:hover {
  background: #44D7B655;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/realTime/solveDialog.vue